import React from 'react';

export const RightArrow = ({ disabled }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0788 12.5H5V11.5H17.0788L11.2865 5.70775L12 5L19 12L12 19L11.2865 18.2923L17.0788 12.5Z"
      fill={disabled ? '#808080' : 'black'}
    />
  </svg>
);

export const LeftArrow = ({ disabled }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.92125 12.5L12.7135 18.2923L12 19L5 12L12 5L12.7135 5.70775L6.92125 11.5H19V12.5H6.92125Z"
      fill={disabled ? '#808080' : 'black'}
    />
  </svg>
);
